export let GAME_FONT: string = "OpenSans-SemiBold";
export let GAME_FONT_BOLD: string = "OpenSans-Bold";
export let GAME_FONT_ITALIC: string = "OpenSans-Italic";

// 1st July 2030
export const GAME_START_TIMESTAMP = 1909087200000;

// 9am
export const DAY_START_TIMESTAMP =  1000 * 60 * 60 * 9;

export const ONE_DAY_MILLISECONDS = 1000 * 60 * 60 * 24;